import {debounce} from "./debounce.js";

const scrollObserver = ({
                            items,
                            rootMargin = "-150px 0px",
                            threshold = 0.05,
                            targetClass = "animated",
                            instance = {}
                        }, callback) => {
    if (!items || items.length === 0) return;

    let options = {
        root: null,
        rootMargin,
        threshold,
    };

    let observer = new IntersectionObserver(beTouching, options);
    items.forEach(item => observer.observe(item));

    // Vimeo options
    const vimeoOptions = {
        badge: 0,
    };

    // Cookiebot
    const hasVimeoItems = [...items].some(item => item.classList.contains('vimeo-iframe'));
    const hasMarketingConsent = () => typeof Cookiebot !== 'undefined' && Cookiebot?.consent?.marketing;
    const updateVimeoConsentState = (vimeoIframe) => {
        const hasCookiebotMarketing = hasMarketingConsent();
        vimeoIframe.classList.toggle('vimeo-iframe--enabled', hasCookiebotMarketing);
        vimeoIframe.classList.toggle('vimeo-iframe--blocked', !hasCookiebotMarketing);

        if (hasCookiebotMarketing) {
            const iframe = vimeoIframe.querySelector('iframe[data-cookieblock-src]');
            if (iframe && !iframe.getAttribute('src')) {
                iframe.setAttribute('src', iframe.dataset.cookieblockSrc);
            }
        }
    };

    if (hasVimeoItems) {
        window.addEventListener('CookiebotOnAccept', () => {
            document.querySelectorAll('.vimeo-iframe').forEach(updateVimeoConsentState);
        });
        window.addEventListener('CookiebotOnDecline', () => {
            document.querySelectorAll('.vimeo-iframe').forEach(updateVimeoConsentState);
        });
    }

    // Handle Items Intersecting
    function beTouching(entries, ob) {
        entries.forEach(entry => {
            if (callback) {
                callback(entry.isIntersecting)
                return
            }
            if (
                entry.target.classList.contains('vimeo-iframe')
                && entry.target.hasAttribute('data-video-id')
            ) {
                const hasIframe = entry.target.querySelector('iframe');
                let queryString = new URLSearchParams(vimeoOptions).toString();
                queryString += entry.target.classList.contains('card__video-preview') ? '&background=1&loop=1&autopause=0' : '';
                updateVimeoConsentState(entry.target);

                if (entry.isIntersecting && !hasIframe) {
                    let iframe = document.createElement("iframe");
                    const src = `https://player.vimeo.com/video/${entry.target.dataset.videoId}?${queryString}`;
                    if (hasMarketingConsent()) {
                        iframe.setAttribute('src', src);
                        iframe.setAttribute('data-cookieconsent', 'marketing');
                    } else {
                        iframe.setAttribute('data-cookieblock-src', src);
                        iframe.setAttribute('data-cookieconsent', 'marketing');
                    }
                    entry.target.appendChild(iframe);
                    updateVimeoConsentState(entry.target);
                }
            } else if (entry.isIntersecting) {
                entry.target.classList.add(targetClass);
                ob.unobserve(entry.target);
            }
        });
    }

    /**
     * Parallax
     * @type {string}
     */
    let parallaxItems = document.querySelectorAll('.parallax');
    if (parallaxItems.length) {
        const handleParallaxScroll = () => {
            parallaxItems.forEach((item) => {
                const parallaxValue = item.dataset.parallax ?? 10
                const direction = item.dataset.direction === 'down' ? -1 : 1
                let dataParallax = item.getBoundingClientRect().top / parallaxValue * direction + 'px';
                item.style.transform = 'translate3d(0, ' + dataParallax + ', 0)';
            });
        }
        handleParallaxScroll();
        const onScroll = debounce(() => handleParallaxScroll(), 6);
        window.addEventListener("scroll", onScroll);
    }
}

export default scrollObserver;
